import Gratitude from "./Gratitude";
import SiteText from "./SiteText";
import Styles from "./Styles";
import { useEffect, useState } from 'react';

function ValidatePhoneNumber(value){
    const phoneRegex=/^(?:\([0-9]{3}\)|[0-9]{3})[- ]?[0-9]{3}[- ]?[0-9]{4}$/;
    var returnValue = false;

    if (value === '' || phoneRegex.test(value)) {
        returnValue = true;
    }

    return returnValue;
}

function ValidateEmail(value){
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var returnValue = false;
    
    if (value === '' || emailRegex.test(value)) {
        returnValue = true;
    }

    return returnValue;
}

const Quote = () => {
    const [EmailIsValid, setEmailIsValid]  = useState(true);
    const [PhoneNumberIsValid, setPhoneNumberIsValid]  = useState(true);
    const [InputError, setInputError] = useState(false);
    const [Submitted, setSubmitted] = useState(false);

    const [formData, setFormData] = useState({
        name: "", 
        email: "", 
        phoneNumber: "",
        address: "",
        additionalInfo: "",
    });

    const [source, setSource] = useState(null);

    useEffect(() => {
        var prev = sessionStorage.getItem("previousRoute")

        if (prev === "/") {
            prev = "Main Page"
        } else if (!prev) {
            prev = "Direct Visit"
        }

        console.log(prev);

        setSource(prev);
    }, []);

    const handleSubmit = event => {
        event.preventDefault();

        if (EmailIsValid && PhoneNumberIsValid) {
            setInputError(false)

            const myForm = event.target;
            const formData = new FormData(myForm);

            fetch("https://formsubmit.co/ajax/2136fba9de35505db9f286b6d952ea80", {
                method: "POST",
                headers: { 
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    name: formData.get(SiteText.Quote.Fields.Name.FormName), 
                    email: formData.get(SiteText.Quote.Fields.Email.FormName), 
                    phoneNumber: formData.get(SiteText.Quote.Fields.PhoneNumber.FormName), 
                    address: formData.get(SiteText.Quote.Fields.Address.FormName), 
                    additionalInfo: formData.get(SiteText.Quote.Fields.AdditionalInfo.FormName),
                    cameFrom: source
                })
            })
                .then(response => response.json())
                .then(() => {
                    setFormData({
                        name: "", 
                        email: "", 
                        phoneNumber: "",
                        address: "",
                        additionalInfo: "",
                    })
                })
                .then(() => {setSubmitted(true)})
                .catch(error => alert(error));
        } else {
            setInputError(true)
        }
    }

    const handleChange = (input) => {
        const { name, value } = input.target;
        if(name === "email") {setEmailIsValid(ValidateEmail(value))}
        if(name === "phoneNumber") {setPhoneNumberIsValid(ValidatePhoneNumber(value))}
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    return <div className="flex justify-center">
        <Gratitude className={`${Submitted ? "" : "hidden"}`}/>
        <div className={`m-6 p-6 bg-secondary/75 w-full lg:w-1/2 rounded-xl ${Submitted ? "hidden" : ""}`}>
            <div className="text-5xl text-center mb-12 text-primary">
                {SiteText.Quote.Title}
            </div>
            <div className={`rounded-xl bg-red-300 p-4 ${InputError?"":"hidden"}`}>
                {SiteText.Quote.Error}
            </div>
            <form 
                name="quote"
                onSubmit={handleSubmit}
                className="flex flex-col items-center justify-center mt-8"
            >
                <input type="hidden" name="_template" value="table"></input>
                <input
                    required={true}
                    name={SiteText.Quote.Fields.Name.FormName}
                    placeholder={SiteText.Quote.Fields.Name.PlaceHolder}
                    className={Styles.Quote.Input + "border-secondaryDark"}
                    value={formData.name}
                    onChange={handleChange}
                />
                <input 
                    type="email"
                    name={SiteText.Quote.Fields.Email.FormName}
                    placeholder={SiteText.Quote.Fields.Email.PlaceHolder}
                    className={Styles.Quote.Input + `${EmailIsValid?"border-secondaryDark":"border-red-600"}`}
                    value={formData.email}
                    onChange={handleChange}
                />
                <input 
                    type="tel"
                    required={true}
                    name={SiteText.Quote.Fields.PhoneNumber.FormName}
                    placeholder={SiteText.Quote.Fields.PhoneNumber.PlaceHolder}
                    className={Styles.Quote.Input + `${PhoneNumberIsValid?"border-secondaryDark":"border-red-600"}`}
                    value={formData.phoneNumber}
                    onChange={handleChange}
                />
                <input 
                    name={SiteText.Quote.Fields.Address.FormName}
                    placeholder={SiteText.Quote.Fields.Address.PlaceHolder}
                    className={Styles.Quote.Input + "border-secondaryDark"}
                    value={formData.address}
                    onChange={handleChange}
                />
                <textarea
                    required={true}
                    name={SiteText.Quote.Fields.AdditionalInfo.FormName}
                    placeholder={SiteText.Quote.Fields.AdditionalInfo.PlaceHolder}
                    className={"resize-none p-4 m-2 rounded-xl w-5/6 lg:w-1/2 border-2 border-secondaryDark"}
                    value={formData.additionalInfo}
                    onChange={handleChange}
                />
                <button className={Styles.Quote.Button}>
                    {SiteText.Quote.Submit}
                </button>
            </form>
        </div>
    </div>
};

export default Quote;